import React from "react";
import "./ClimateIndicator.scss";

interface IProps {
    year: number;
    emission: boolean;
    showClimateInfo: boolean;
    setShowClimateInfo: (state: boolean) => void;
    visible: boolean;
}

export function ClimateIndicator({ year, emission, setShowClimateInfo, showClimateInfo, visible }: IProps) {
    const contents: {
        high: number[],
        low: number[],
    } = {
        high: [
            33.63,
            34,
            36.13,
            35,
            36.60,
            24,
            37.14,
            20,
            37.87,
            17,
            37.43,
            8,
            39.43,
            9
        ],
        low: [
            33.63,
            34,
            34.20,
            29,
            34.31,
            23,
            34.85,
            32,
            35.3,
            34,
            33.62,
            26,
            33.89,
            30
        ],
    }

    return (
        <>

            <div className={`climate-indicator-wrapper ${showClimateInfo ? 'show-climate-info' : ''} ${visible ? 'visible' : ''}`} data-year={year} data-emission={emission ? 'high' : 'low'}>
                {Object.keys(contents).map((key: string, emissionIndex: number) => {
                    const contentKey = key as 'high' | 'low';
                    return <div key={emissionIndex} className="climate-indicator-side">
                        {contents[contentKey].map((number: number, index: number) => {
                            const title = index %2 ? 'Frost days<br /><small>per year</small>' : 'Max<br />temperature';
                            let parsedNumber = number.toString();
                            if (!(index %2)) {
                                parsedNumber = `${number.toString().split('.').join(',')}˚`
                            }
                            return <div className="climate-indicator" key={index}>
                                <div>

                                    <h3 dangerouslySetInnerHTML={{__html: title}} />
                                    <h2>{parsedNumber}</h2>
                                </div>
                            </div>
                        })}
                    </div>;
                })}
                <div className="small-info-button-wrapper">
                    <div className="small-info-button-container">
                        <button className="info-button" onClick={() => setShowClimateInfo(!showClimateInfo)}>i</button>
                        <div className="pulse"/>
                        <div className="pulse"/>
                        <div className="pulse"/>
                    </div>
                </div>
            </div>
            <div className="climate-info-line" />
        </>
    )
}
